<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" RestrictFocus >

  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.applicationName.nullable}">{{ fields.applicationName.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown formControlName="applicationId" [options]="applications" (onChange)="onChangeApplication($event)" filter="filter" [style]="{ 'width': '100%'}"> </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.applicationName"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.app_icon.nullable}">{{ fields.app_icon.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="app_icon" pInputText [maxlength]="fields.app_icon.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.app_icon"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.msBaseUrl.nullable}">{{ fields.msBaseUrl.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="msBaseUrl" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.msBaseUrl"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button
        type="submit" class="k-generic-btn" pButton icon="fa fa-plus"
        label="{{dialogBoxCompanyApplications.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'common.application' |translate }}">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/company/applications/companyApplicationsForm.component.html